// 検索条件の localStorage 保存(薄いラッパ)。
//
// 値は URL と同じ正規形クエリ文字列をそのまま保存する。復元も orderSearchCodec を
// 通すため、検証・権限クランプのコードパスが URL と1本化される。
// キーは画面と uid でスコープする(共有端末で別ユーザーの条件を引き継がない。
// 権限クランプがあるため引き継いでも危険はないが、混乱のもとになる)。
// localStorage はプライベートモードや設定で例外になり得るため必ず try/catch する。
const STORAGE_PREFIX = "orderSearch:v1";

const storageKey = (screen, uid) => `${STORAGE_PREFIX}:${screen}:${uid || "anon"}`;

export const loadStoredSearchParams = (screen, uid) => {
  try {
    const value = window.localStorage.getItem(storageKey(screen, uid));
    return typeof value === "string" && value.length > 0 ? value : null;
  } catch (e) {
    return null;
  }
};

export const saveStoredSearchParams = (screen, uid, paramsString) => {
  try {
    window.localStorage.setItem(storageKey(screen, uid), paramsString);
  } catch (e) {
    // 保存できなくても検索機能自体は成立する(次回は既定値から始まるだけ)
  }
};
